import API from "../../../app/api";

export const getShopbyDesign = async () => {
  try {
    const res = await API.get("banners/shop-by-design");
    if (!res.data?.success) {
      throw new Error(res.data?.message || "Failed to fetch Shop By Design");
    }
    return res.data?.data || [];
  } catch (error) {
    console.error("getShopbyDesign error:", error);
    return [];
  }
};